import { createContext, useContext, useState } from "react";

const dict = {
  bm: {
    "nav.modules": "Modul", "nav.plans": "Pelan", "nav.security": "Keselamatan", "nav.pricing": "Harga",
    "nav.faq": "FAQ", "nav.login": "Log Masuk", "nav.bookDemo": "Tempah Demo", "nav.startTrial": "Mula Percubaan Percuma",
    "hero.badge": "Sistem Operasi Koperasi • SaaS Berbilang Penyewa",
    "hero.title": "Urus Koperasi Dalam Satu Platform.",
    "hero.sub": "Daripada keahlian, saham, yuran dan pembiayaan sehingga kewangan, AGM, audit dan AI — semuanya dalam satu sistem.",
    "hero.pill1": "Satu Rekod Ahli", "hero.pill2": "Satu Ledger Kewangan", "hero.pill3": "Satu Portal Ahli",
    "hero.cta1": "Tempah Demo", "hero.cta2": "Mula Percubaan 14 Hari",
    "hero.note": "Tanpa kad kredit. Data demo tersedia serta-merta.",
    "prob.title": "Masalah Yang Kami Selesaikan",
    "prob.1": "Fail Excel berselerak di merata tempat", "prob.2": "Penyata ahli disediakan secara manual",
    "prob.3": "Rekod kelulusan hilang entah ke mana", "prob.4": "Sistem berasingan untuk ahli, pembiayaan dan AGM",
    "prob.outro": "Semua operasi dalam satu platform terkawal.",
    "one.title": "Satu Platform. Enam Perkara Penting.",
    "one.1.t": "SATU REKOD AHLI", "one.1.d": "Profil, KYC, saham dan yuran setiap ahli dalam satu rekod bersepadu.",
    "one.2.t": "SATU LEDGER KEWANGAN", "one.2.d": "Semua transaksi direkodkan dalam ledger kewangan yang sama.",
    "one.3.t": "SATU SISTEM KELULUSAN", "one.3.d": "Aliran maker-checker untuk pendaftaran ahli dan pengeluaran saham.",
    "one.4.t": "SATU JEJAK AUDIT", "one.4.d": "Setiap tindakan direkodkan — siapa, apa dan bila.",
    "one.5.t": "SATU PORTAL AHLI", "one.5.d": "Ahli semak saham, yuran dan resit sendiri, bila-bila masa.",
    "one.6.t": "SATU PEMBANTU AI", "one.6.d": "Pembantu AI koperasi yang memahami data ahli dan menjawab dalam BM atau EN.",
    "mod.title": "Modul Platform",
    "mod.core": "TERAS", "mod.core.d": "Ahli, Saham, Yuran, Bayaran, Dokumen",
    "mod.fin": "KEWANGAN", "mod.fin.d": "Perakaunan, Bank, Belanjawan",
    "mod.lend": "PEMBIAYAAN", "mod.lend.d": "Permohonan, Bayaran Balik, Tunggakan",
    "mod.gov": "TADBIR URUS", "mod.gov.d": "AGM, Lembaga, Audit, Risiko, Pematuhan",
    "mod.ai": "AI", "mod.ai.d": "Pembantu Ahli, Kewangan, Audit, Pengurusan",
    "mod.plat": "PLATFORM", "mod.plat.d": "Multi-Tenant, Billing, White Label, API, Reseller",
    "ai.title": "Koperasi AI",
    "ai.sub": "Pembantu pintar untuk ahli dan pengurusan — mematuhi kebenaran setiap penyewa.",
    "sec.title": "Keselamatan Gred Enterprise",
    "sec.1": "Pengasingan Penyewa (Tenant Isolation)", "sec.2": "RBAC & Maker-Checker",
    "sec.3": "Jejak Audit Penuh", "sec.4": "Enkripsi & Sandaran",
    "price.title": "Harga Telus. Skala Mengikut Koperasi Anda.",
    "price.monthly": "Bulanan", "price.annual": "Tahunan (2 bulan percuma)",
    "price.perMonth": "/bulan", "price.custom": "Harga Khas",
    "price.popular": "PALING POPULAR", "price.choose": "Pilih Pelan", "price.contact": "Hubungi Jualan",
    "price.trial": "Percubaan percuma 14 hari termasuk data demo",
    "plan.starter.target": "Koperasi kecil — sehingga 1,000 ahli",
    "plan.professional.target": "Koperasi sederhana — sehingga 10,000 ahli",
    "plan.business.target": "Koperasi besar & gabungan",
    "plan.enterprise.target": "Persekitaran berdedikasi & keperluan tersuai",
    "demo.title": "Tempah Demo",
    "demo.sub": "Isi borang ini — pasukan kami akan hubungi anda untuk sesi demo langsung.",
    "demo.coop": "Nama Koperasi", "demo.person": "Nama Pegawai", "demo.email": "Emel",
    "demo.phone": "Telefon", "demo.size": "Saiz Keahlian", "demo.msg": "Mesej / Masalah Utama",
    "demo.submit": "Hantar Permintaan Demo", "demo.done": "Terima kasih! Kami akan menghubungi anda tidak lama lagi.",
    "faq.title": "Soalan Lazim",
    "footer.tag": "Satu Platform Untuk Mengurus Ahli, Saham, Yuran, Pembiayaan, Kewangan, AGM, Tadbir Urus dan AI Koperasi.",
    "login.title": "Log masuk ke KOPERA", "login.sub": "Satu akaun Google untuk semua portal",
    "login.google": "Teruskan dengan Google",
    "dash.overview": "Ringkasan", "dash.members": "Ahli", "dash.finance": "Kewangan", "dash.approvals": "Kelulusan",
    "dash.audit": "Jejak Audit", "dash.reports": "Laporan", "dash.branding": "Jenama (White Label)", "dash.subscription": "Langganan",
    "dash.tenants": "Penyewa", "dash.crm": "Saluran Jualan (CRM)", "dash.billing": "Invois & Bayaran", "dash.resellers": "Reseller",
    "dash.usage": "Penggunaan", "dash.home": "Utama", "dash.shares": "Saham", "dash.fees": "Yuran", "dash.receipts": "Resit",
    "dash.ai": "Pembantu AI",
    "common.logout": "Log Keluar", "common.save": "Simpan", "common.cancel": "Batal", "common.add": "Tambah",
    "common.search": "Cari...", "common.loading": "Memuatkan...", "common.actions": "Tindakan",
    "common.status": "Status", "common.date": "Tarikh", "common.amount": "Amaun", "common.name": "Nama",
  },
  en: {
    "nav.modules": "Modules", "nav.plans": "Plans", "nav.security": "Security", "nav.pricing": "Pricing",
    "nav.faq": "FAQ", "nav.login": "Log In", "nav.bookDemo": "Book Demo", "nav.startTrial": "Start Free Trial",
    "hero.badge": "Cooperative Operating System • Multi-Tenant SaaS",
    "hero.title": "Run Your Cooperative In One Platform.",
    "hero.sub": "From membership, shares, fees and financing to finance, AGM, audit and AI — everything in one system.",
    "hero.pill1": "One Member Record", "hero.pill2": "One Financial Ledger", "hero.pill3": "One Member Portal",
    "hero.cta1": "Book Demo", "hero.cta2": "Start 14-Day Trial",
    "hero.note": "No credit card. Demo data ready instantly.",
    "prob.title": "Problems We Solve",
    "prob.1": "Scattered Excel files everywhere", "prob.2": "Member statements prepared manually",
    "prob.3": "Approval records go missing", "prob.4": "Separate systems for members, financing and AGM",
    "prob.outro": "All operations in one controlled platform.",
    "one.title": "One Platform. Six Essentials.",
    "one.1.t": "ONE MEMBER RECORD", "one.1.d": "Every member's profile, KYC, shares and fees in one integrated record.",
    "one.2.t": "ONE FINANCIAL LEDGER", "one.2.d": "All transactions recorded in the same financial ledger.",
    "one.3.t": "ONE APPROVAL SYSTEM", "one.3.d": "Maker-checker flows for member registration and share withdrawals.",
    "one.4.t": "ONE AUDIT TRAIL", "one.4.d": "Every action recorded — who, what and when.",
    "one.5.t": "ONE MEMBER PORTAL", "one.5.d": "Members check shares, fees and receipts themselves, anytime.",
    "one.6.t": "ONE AI ASSISTANT", "one.6.d": "A cooperative AI assistant that understands member data and answers in BM or EN.",
    "mod.title": "Platform Modules",
    "mod.core": "CORE", "mod.core.d": "Members, Shares, Fees, Payments, Documents",
    "mod.fin": "FINANCE", "mod.fin.d": "Accounting, Bank, Budgeting",
    "mod.lend": "FINANCING", "mod.lend.d": "Applications, Repayment, Arrears",
    "mod.gov": "GOVERNANCE", "mod.gov.d": "AGM, Board, Audit, Risk, Compliance",
    "mod.ai": "AI", "mod.ai.d": "Member, Finance, Audit & Management AI",
    "mod.plat": "PLATFORM", "mod.plat.d": "Multi-Tenant, Billing, White Label, API, Reseller",
    "ai.title": "Koperasi AI",
    "ai.sub": "An intelligent assistant for members and management — respecting each tenant's permissions.",
    "sec.title": "Enterprise-Grade Security",
    "sec.1": "Tenant Isolation", "sec.2": "RBAC & Maker-Checker",
    "sec.3": "Full Audit Trail", "sec.4": "Encryption & Backups",
    "price.title": "Transparent Pricing. Scale With Your Cooperative.",
    "price.monthly": "Monthly", "price.annual": "Annual (2 months free)",
    "price.perMonth": "/month", "price.custom": "Custom Pricing",
    "price.popular": "MOST POPULAR", "price.choose": "Choose Plan", "price.contact": "Contact Sales",
    "price.trial": "14-day free trial with demo data included",
    "plan.starter.target": "Small cooperatives — up to 1,000 members",
    "plan.professional.target": "Mid-size cooperatives — up to 10,000 members",
    "plan.business.target": "Large cooperatives & federations",
    "plan.enterprise.target": "Dedicated environment & custom requirements",
    "demo.title": "Book a Demo",
    "demo.sub": "Fill this form — our team will contact you for a live demo session.",
    "demo.coop": "Cooperative Name", "demo.person": "Contact Person", "demo.email": "Email",
    "demo.phone": "Phone", "demo.size": "Membership Size", "demo.msg": "Message / Main Problem",
    "demo.submit": "Request Demo", "demo.done": "Thank you! We will contact you shortly.",
    "faq.title": "Frequently Asked Questions",
    "footer.tag": "One Platform To Manage Members, Shares, Fees, Financing, Finance, AGM, Governance and Cooperative AI.",
    "login.title": "Log in to KOPERA", "login.sub": "One Google account for all portals",
    "login.google": "Continue with Google",
    "dash.overview": "Overview", "dash.members": "Members", "dash.finance": "Finance", "dash.approvals": "Approvals",
    "dash.audit": "Audit Trail", "dash.reports": "Reports", "dash.branding": "Branding (White Label)", "dash.subscription": "Subscription",
    "dash.tenants": "Tenants", "dash.crm": "Sales Pipeline (CRM)", "dash.billing": "Invoices & Payments", "dash.resellers": "Resellers",
    "dash.usage": "Usage", "dash.home": "Home", "dash.shares": "Shares", "dash.fees": "Fees", "dash.receipts": "Receipts",
    "dash.ai": "AI Assistant",
    "common.logout": "Log Out", "common.save": "Save", "common.cancel": "Cancel", "common.add": "Add",
    "common.search": "Search...", "common.loading": "Loading...", "common.actions": "Actions",
    "common.status": "Status", "common.date": "Date", "common.amount": "Amount", "common.name": "Name",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("kop_lang") || "en");
  const toggle = (l) => {
    setLang(l);
    localStorage.setItem("kop_lang", l);
  };
  const t = (key) => dict[lang][key] ?? dict.bm[key] ?? key;
  return <LangContext.Provider value={{ lang, setLang: toggle, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const LangToggle = ({ dark = false }) => {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="language-toggle-button"
      className={`flex items-center rounded-full border text-xs font-semibold overflow-hidden ${
        dark ? "border-white/20 text-white" : "border-brand-deep/20 text-brand-deep"
      }`}
    >
      <button
        data-testid="language-switcher-bm"
        onClick={() => setLang("bm")}
        className={`px-3 py-1.5 transition-colors ${lang === "bm" ? "bg-gold text-brand-dark" : "hover:bg-black/5"}`}
      >
        BM
      </button>
      <button
        data-testid="language-switcher-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 transition-colors ${lang === "en" ? "bg-gold text-brand-dark" : "hover:bg-black/5"}`}
      >
        EN
      </button>
    </div>
  );
};
